import { BalanceAvailability } from "@models/platform-analysis/enums/fee/balanceAvailability";
import { AnalysisVariable } from "@models/platform-analysis/enums/variableName";

export class ManagedAccountPortfolioSetupDTO {
  name?: string;
  ownerId: string = "";
  ownerName?: string = "";
  ownerAvatarUrl?: string = "";
  firmId: string = "";
  firmName?: string = "";
  portfolioSize: number = 0;
  selectedInvestments: SelectedInvestmentDTO[] = [];
}

export class ManagedAccountPortfolioSetupCreateDTO extends ManagedAccountPortfolioSetupDTO {
  analysisInclusion: string = "";
  includingAnalysisId?: string | null = null;
}

export class ManagedAccountPortfolioSetupUpdateDTO extends ManagedAccountPortfolioSetupDTO {
  hasRefreshData: boolean = false;
}

export class InvestmentSelectionDTO {
  shCode: string = "";
  code?: string | null = null;
  name?: string = "";
  managerName?: string | null = null;
  displayName?: string | null = null;
  isSelected?: boolean = false;
  isFavourited?: boolean = false;
  minimumInvestmentSize?: number | null = null;
  isMissingInvestment?: boolean = false;
  availableInIDPS?: boolean = true;
  availableInSuper?: boolean = true;
  balanceAvailability?: BalanceAvailability = BalanceAvailability.Show;
  isUnavailable?: boolean = false;
}

export class SelectedInvestmentDTO extends InvestmentSelectionDTO {
  weight: number | null = null;
  value: number | null = null;
}

export class PortfolioTemplateFeeCalculatorDataDTO {
  variableName: AnalysisVariable = AnalysisVariable.AU_balance_i;
  value: number | null = null;
  weight: number | null = null;
}

export class PortfolioTemplateDTO {
  selectedInvestments: SelectedInvestmentDTO[] = [];
  feeCalculatorData: PortfolioTemplateFeeCalculatorDataDTO[] = [];
}

export class InvestmentQueryOptions {
  managedAccountId: string = "new";
  subProductId?: string = "";
  search?: string = "";
  skip?: number = 0;
  take?: number = 0;
}

export class SelectedPortfolioTemplateDTO {
  id: string = "";
  name: string = "";
  note: string = "";
}

export interface PortfolioInvestmentTypeSelection {
  isChooseMF: boolean;
  isChooseAU: boolean;
  isChooseIntl: boolean;
  isChooseBond: boolean;
  isChooseTD: boolean;
}
